module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Aberdeen-babd65ddbd75978ff0c1da205e57710f.svg";